import axios from 'axios';
import { API_HOST } from '../consts';

const prefix = 'core';

class InstitutionApi {
  constructor() {
    this.endpoint = 'institution';
  }

  list = async (params) => {
    const response = await axios.get(`${API_HOST}/${prefix}/${this.endpoint}`, {
      params,
    });
    return response.data;
  };
}

export {
  // eslint-disable-next-line import/prefer-default-export
  InstitutionApi,
};

export const fetchParceiro = (id) =>
  axios.get(`${API_HOST}/core/partners/${id}`).then((res) => res.data);

export const fetchLinhaPesquisa = (id) =>
  axios.get(`${API_HOST}/core/linha-pesquisa/${id}`).then((res) => res.data);

export const fetchLinhasPesquisa = async () =>
  await axios.get(`${API_HOST}/core/linha-pesquisa`).then((res) => res.data);
export const createLinhaPesquisa = async (data) =>
  await axios.post(`${API_HOST}/core/linha-pesquisa`, data).then((res) => res.data);
export const updateLinhaPesquisa = async (id, data) =>
  await axios
    .patch(`${API_HOST}/core/linha-pesquisa/${id}`, data)
    .then((res) => res.data);

export const deleteLinhaPesquisa = async (id) =>
  await axios.delete(`${API_HOST}/core/linha-pesquisa/${id}`).then((res) => res.data);
